{
  "$id": "wealthlane://forms/espp/ui",
  "schema": "./model.json",
  "semanticId": "esppOfferingPeriodForm",
  "wrapper": {},
  "layout": [
    {
      "rowId": "plan_row",
      "fields": [
        {
          "scope": "#/properties/planId",
          "minCols": 2,
          "maxCols": 2,
          "minWidthPx": 200,
          "maxWidthPx": 400
        }
      ]
    },
    {
      "rowId": "main_fields_row",
      "fields": [
        {
          "scope": "#/properties/name",
          "minCols": 2,
          "maxCols": 2,
          "minWidthPx": 200,
          "maxWidthPx": 400,
          "startNewRow": true
        },
        {
          "scope": "#/properties/offeringPeriodStartDate",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 160,
          "maxWidthPx": 220
        },
        {
          "scope": "#/properties/offeringPeriodEndDate",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 160,
          "maxWidthPx": 220
        },
        {
          "scope": "#/properties/fmvAtStart",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 140,
          "maxWidthPx": 220
        },
        {
          "scope": "#/properties/offeringPeriodType",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 180,
          "maxWidthPx": 280
        }
      ]
    },
    {
      "rowId": "discount_lookback_row",
      "fields": [
        {
          "scope": "#/properties/discountPercent",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 120,
          "maxWidthPx": 180,
          "startNewRow": true
        },
        {
          "scope": "#/properties/lookback",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 100,
          "maxWidthPx": 140
        },
        {
          "scope": "#/properties/description",
          "minCols": 3,
          "maxCols": 3,
          "minWidthPx": 300,
          "maxWidthPx": 600
        }
      ]
    },
    {
      "rowId": "enrollment_window_rules",
      "title": "Enrollment Window Rules",
      "fields": [
        {
          "scope": "#/properties/enrollmentWindowMaxChanges",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 160,
          "maxWidthPx": 240
        },
        {
          "scope": "#/properties/enrollStartDaysPriorToPurchasePeriod",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 160,
          "maxWidthPx": 240
        },
        {
          "scope": "#/properties/enrollDays",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 160,
          "maxWidthPx": 240
        }
      ]
    },
    {
      "rowId": "change_window_rules",
      "title": "Change Window Rules",
      "fields": [
        {
          "scope": "#/properties/changeWindowMaxUpChanges",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 160,
          "maxWidthPx": 240
        },
        {
          "scope": "#/properties/changeWindowMaxDownChanges",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 160,
          "maxWidthPx": 240
        },
        {
          "scope": "#/properties/changeEndDaysPriorToPurchaseDate",
          "minCols": 1,
          "maxCols": 2,
          "minWidthPx": 200,
          "maxWidthPx": 320
        }
      ]
    },
    {
      "type": "column-group",
      "rowId": "participant_choice",
      "columns": [
        {
          "title": "Suspension Participant Choice",
          "fields": [
            {
              "scope": "#/properties/allowParticipantToSuspendWithPurchase",
              "minCols": 1,
              "maxCols": 1,
              "minWidthPx": 140,
              "maxWidthPx": 600,
              "startNewRow": true
            },
            {
              "scope": "#/properties/allowParticipantToSuspendWithoutPurchase",
              "minCols": 1,
              "maxCols": 1,
              "minWidthPx": 140,
              "maxWidthPx": 600,
              "startNewRow": true
            }
          ]
        },
        {
          "title": "Withdraw Participant Choice",
          "fields": [
            {
              "scope": "#/properties/allowParticipantToWithdrawWithPurchase",
              "minCols": 1,
              "maxCols": 1,
              "minWidthPx": 140,
              "maxWidthPx": 600,
              "startNewRow": true
            },
            {
              "scope": "#/properties/allowParticipantToWithdrawWithoutPurchase",
              "minCols": 1,
              "maxCols": 1,
              "minWidthPx": 140,
              "maxWidthPx": 600,
              "startNewRow": true
            }
          ]
        }
      ]
    },
    {
      "rowId": "rollover_rule",
      "title": "Rollover Rule",
      "columns": 5,
      "fields": [
        {
          "scope": "#/properties/rolloverEnrollment",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 40,
          "maxWidthPx": 200
        },
        {
          "scope": "#/properties/residualCashDisposition",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 160,
          "maxWidthPx": 240
        },
        {
          "scope": "#/properties/nextOfferingPeriodId",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 160,
          "maxWidthPx": 240
        }
      ]
    },
    {
      "type": "each",
      "field": "#/properties/purchasePeriods",
      "presentation": "table",
      "rowId": "purchase_periods_table",
      "title": "Purchase Periods",
      "addButton": {
        "label": "Add Purchase Period",
        "variant": "primary-outline",
        "icon": "add_circle",
        "position": "top-right"
      },
      "removeButton": {
        "icon": "delete",
        "variant": "inline-icon"
      },
      "resetButton": {
        "icon": "refresh"
      },
      "itemFields": [
        {
          "name": "periodStartDate",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 155,
          "maxWidthPx": 160
        },
        {
          "name": "periodEndDate",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 155,
          "maxWidthPx": 160
        },
        {
          "name": "enrollmentWindowStartDate",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 155,
          "maxWidthPx": 160
        },
        {
          "name": "enrollmentWindowEndDate",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 155,
          "maxWidthPx": 160
        },
        {
          "name": "changeWindowStartDate",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 155,
          "maxWidthPx": 160
        },
        {
          "name": "changeWindowEndDate",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 155,
          "maxWidthPx": 160
        },
        {
          "name": "purchaseDate",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 155,
          "maxWidthPx": 160
        },
        {
          "name": "purchasePrice",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 100,
          "maxWidthPx": 120
        }
      ],
      "rowActions": [
        { "actionId": "VIEW_ESPP_PARTICIPANTS", "label": "View ESPP Participant", "onlyInMode": "view" },
        { "actionId": "IMPORT_ESPP_ELIGIBILITY", "label": "Import Eligibility", "onlyInMode": "view" },
        { "actionId": "EXPORT_ESPP_ELIGIBILITY", "label": "Export Eligibility", "onlyInMode": "view" },
        { "actionId": "IMPORT_ESPP_ENROLLMENT", "label": "Import Enrollment", "onlyInMode": "view" },
        { "actionId": "EXPORT_ESPP_ENROLLMENT", "label": "Export Enrollment", "onlyInMode": "view" },
        { "actionId": "IMPORT_ESPP_PURCHASE", "label": "Import Purchase", "onlyInMode": "view" },
        { "actionId": "EXPORT_ESPP_PURCHASE", "label": "Export Purchase", "onlyInMode": "view" }
      ]
    }
  ]
}
